import React, { Component } from 'react';

import { openWindow } from '@umu/umu-util';

export interface IDialogFooterButtonProps {
    href?: string;
    target?: '_blank' | '_self';
    onClick?: () => void;
    className?: string;
    disabled?: boolean;
}

export default class DialogFooterButton extends Component<IDialogFooterButtonProps> {
    constructor(props: IDialogFooterButtonProps) {
        super(props);
        this.state = {};
        this.onClick = this.onClick.bind(this);
    }

    public onClick() {
        const { onClick, href, target, disabled } = this.props;
        if (disabled) {
            return;
        }
        if (onClick) {
            onClick();
        } else if (href) {
            openWindow(href, target);
        }
    }

    public render() {
        const props = this.props;
        return (
            <div className="dialog-option">
                <button
                    className={`btn ${props.className || ''} ${props.disabled && 'disabled'}`}
                    onClick={() => this.onClick()}
                >
                    {props.children}
                </button>
            </div>
        );
    }
}
